<style>
@import '../../custom/css/perfil.css';
@import '../../custom/css/professional.css';
</style>

<template>
  <div class="perfil mt-5">
    <div class="row m-0" v-if="profissional !== null">
      <div class="col-12">
        <h1 class="font-weight-bold text-uppercase" id="inicio">Perfil</h1>
        <hr class="linha-amarela" />
        <div class="text-center" v-if="profissional[0].plano !== null">
          <h3 class>Seu plano atual é:</h3>
          <div class="plan-card-bronze">
            <i class="fas fa-crown crown"></i>
            <span v-if="profissional[0].plano.id === ProfessionalPlans.BRONZE">
              <h4 class="text-uppercase font-weight-bold">Plano Bronze</h4>
              <i class="fas fa-vial"></i>
            </span>
            <span
              v-else-if="profissional[0].plano.id === ProfessionalPlans.SILVER"
            >
              <h4 class="text-uppercase font-weight-bold">Plano Prata</h4>
              <i class="fas fa-medal"></i>
            </span>
            <span
              v-else-if="profissional[0].plano.id === ProfessionalPlans.GOLD"
            >
              <h4 class="text-uppercase font-weight-bold">Plano Ouro</h4>
              <i class="fas fa-trophy"></i>
            </span>
            <span v-if="profissional[0].plano.id === ProfessionalPlans.DIAMOND">
              <h4 class="text-uppercase font-weight-bold">Plano Diamante</h4>
              <i class="fas fa-gem"></i>
            </span>
            <span v-if="profissional[0].plano.id === ProfessionalPlans.FREE">
              <h4 class="text-uppercase font-weight-bold">Plano Gratuito</h4>
              <i class="fas fa-gift"></i>
            </span>
          </div>
          <p
            class="fs-14 mb-2"
            v-if="profissional[0].plano.id !== ProfessionalPlans.FREE"
          >
            Caso queira mudar ou cancelar seu plano entre em contato com nossa
            equipe &#x1F600;
          </p>
          <p v-else class="text-center">
            Alcance centenas de clientes melhorando a divulgação do seu perfil
            <button
              class="btn btn-lg d-block bg-orange fs-16 mx-auto text-white my-2"
              @click="
                aviso(
                  'Para assinar um plano, baixe nosso aplicativo!',
                  'success'
                )
              "
            >
              <span>Turbine seu anúncio</span>
              <i class="fas fa-external-link-alt ml-2 fs-14"></i>
            </button>
          </p>
        </div>
        <!-- <div v-else>
          <div class="text-center mb-3">
            Atualmente não existe nenhum plano contratado &#x1F62D;
            <br />Você pode anunciar seu trabalho para mais de
            <strong>10000 possíveis clientes!</strong>
            <router-link to="">
              <button
                class="btn btn-lg d-block bg-orange fs-16 mx-auto text-white my-2"
                @click="
                  aviso(
                    'Para assinar um plano, baixe nosso aplicativo!',
                    'success'
                  )
                "
              >
                <span>Saiba mais</span>
                <i class="fas fa-external-link-alt ml-2 fs-14"></i>
              </button>
            </router-link>
          </div>
        </div> -->
        <hr class="mb-3" />
        <h5 class="font-weight-bold text-uppercase">Meus Dados</h5>
        <h6>Adicione seus dados e em seguida clique em salvar.</h6>
        <Visualizations
          v-if="
            profissional[0].plano &&
            profissional[0].plano.id &&
            profissional[0].plano.id !== ProfessionalPlans.FREE
          "
          :numberOfVisualizations="dadosUsuario.informacoes.visualizacoes"
        />
        <table class="w-100">
          <tr>
            <th class>Foto Principal:</th>
          </tr>
          <tr v-if="profissional[0].foto_principal !== null">
            <div class="foto_principal position-relative m-b-15">
              <div class="btn-exc c-pointer" @click="removerProfFoto()">
                <i class="fas fa-times"></i>
              </div>
              <a class="pointer">
                <img
                  :src="`${getImagesAddress}` + profissional[0].foto_principal"
                  class="obj w-100 h-100"
                  alt="Foto principal do profissional"
                />
              </a>
            </div>
          </tr>
          <tr v-else>
            <!-- Add foto principal -->
            <div class="row m-0">
              <div class="custom-file">
                <a class="c-pointer">
                  <input
                    type="file"
                    id="foto_principal"
                    lang="pt"
                    class="custom-file-input c-pointer"
                    @change="adicionarFotoPrincipalNaTroca()"
                  />
                  <label for="foto_principal" class="custom-file-label"
                    >Clique aqui e selecione uma imagem para ser a sua foto
                    principal</label
                  >
                </a>
              </div>
              <div class="col-lg-12 text-center p-0">
                <b-button
                  variant="success"
                  class="text-uppercase m-10-0 pl-5 pr-5"
                  @click="updateImageAndDescription()"
                >
                  Salvar imagem do Perfil
                </b-button>
              </div>
            </div>
            <!-- Fim Add foto principal -->
          </tr>
          <tr v-if="foto_principal !== null">
            <th class>Foto a ser inserida:</th>
          </tr>
          <tr v-if="foto_principal !== null">
            <div class="foto_principal position-relative m-b-15">
              <div class="btn-exc" @click="removerPrincipal()">
                <i class="fas fa-times"></i>
              </div>
              <a class="pointer">
                <img
                  :src="`${getImagesAddress}` + foto_principal"
                  class="obj w-100 h-100"
                  alt="Foto principal do profissional"
                />
              </a>
            </div>
          </tr>
          <tr v-if="this.profissional[0].plano_id !== null">
            <div class="custom-file">
              <a class="c-pointer">
                <input
                  type="file"
                  id="foto_principal"
                  lang="pt"
                  class="custom-file-input c-pointer"
                  @change="adicionarFotoPrincipalNaTroca()"
                />
                <label for="foto_principal" class="custom-file-label"
                  >Clique aqui e selecione uma imagem para ser a sua foto
                  principal</label
                >
              </a>
            </div>
            <div class="mt-3">
              <p
                class="d-flex flex-row align-items-center justify-content-between"
              >
                <label class="font-weight-bold" for="txtProfessionalDescription"
                  >Resumo:</label
                >
                <span
                  class="character-count"
                  v-if="this.profissional[0].profissional_resumo"
                >
                  {{ 500 - this.profissional[0].profissional_resumo.length }}
                  caracteres disponíveis
                </span>
              </p>
              <textarea
                v-model="profissional[0].profissional_resumo"
                class="professionalDescription"
                name="txtProfessionalDescription"
                id="txtProfessionalDescription"
                placeholder="Escreva uma breve resumo sobre o seu trabalho..."
                minlength="10"
                maxlength="500"
                rows="6"
              ></textarea>
            </div>
            <div class="row m-0">
              <div class="col-lg-12 p-0">
                <b-button
                  variant="success"
                  class="text-uppercase m-10-0"
                  @click="updateImageAndDescription()"
                >
                  Salvar Perfil
                </b-button>
              </div>
            </div>
          </tr>
          <hr class="my-3" />
          <tr>
            <th class>Profissões:</th>
          </tr>
          <tr v-if="profProfissoes !== []">
            <div class="row m-0">
              <div
                class="col p-0"
                v-for="(profissoes, index) in profProfissoes"
                :key="index"
              >
                <div class="btn-remove" @click="removerProfissoes(index)">
                  <i class="fas fa-times" style=""></i>
                </div>
                <v-select
                  class="pr-2 mb-3"
                  v-model="profProfissoes[index]"
                  label="nome"
                  :options="tipoProfissoes"
                  placeholder="Digite uma profissão"
                ></v-select>
              </div>
            </div>
            <div
              class="fs-14 btn bg-orange text-white btn-add-trab text-uppercase"
              @click="adicionarProfissao()"
            >
              Adicionar
            </div>
            <button
              class="fs-14 btn btn btn-success btn-atualizar text-uppercase"
              @click="atualizarProfissao()"
            >
              Salvar Profissões
            </button>
          </tr>
          <tr v-else>
            <div
              class="fs-14 btn bg-orange text-white btn-add-trab text-uppercase"
              @click="adicionarProfissao()"
            >
              Adicionar
            </div>
            <div
              class="fs-14 btn btn-success btn-atualizar text-uppercase"
              @click="atualizarProfissao()"
            >
              Salvar Profissões
            </div>
          </tr>

          <tr>
            <th class>Cidades de Atuação:</th>
          </tr>
          <tr v-if="profCidades !== []">
            <div class="row m-0">
              <div
                class="col-12 p-0 mb-2"
                v-for="(cidade, index) in profCidades"
                :key="index"
              >
                <div class="btn-remove" @click="removerCidades(index)">
                  <i class="fas fa-times"></i>
                </div>
                <v-select
                  class="p-right-10px"
                  v-model="profCidades[index]"
                  label="nome"
                  :options="cidades"
                  placeholder="Digite uma cidade"
                ></v-select>
              </div>
            </div>
            <div
              class="fs-14 btn bg-orange text-white btn-add-trab text-uppercase"
              @click="adicionarCidade()"
            >
              Adicionar
            </div>
            <div
              class="fs-14 btn btn-success btn-atualizar text-uppercase"
              @click="atualizarCidade()"
            >
              Salvar Cidades
            </div>
          </tr>
          <tr v-else>
            <td>
              <div
                class="fs-14 btnbg-orange text-white btn-add-trab text-uppercase"
                @click="adicionarCidade()"
              >
                Adicionar
              </div>
              <div
                class="fs-14 btn btn-success btn-atualizar text-uppercase"
                @click="atualizarCidade()"
              >
                Salvar Cidades
              </div>
            </td>
          </tr>

          <tr>
            <th class>Links:</th>
          </tr>
          <tr v-if="profLinks !== []">
            <td>
              <div class="row m-0">
                <div
                  class="col-12 p-0 link mb-2"
                  v-for="(link, index) in profLinks"
                  :key="index"
                >
                  <div class="btn-remove" @click="removerLinks(index)">
                    <i class="fas fa-times"></i>
                  </div>
                  <input type="text" class="form-control" v-model="link.link" />
                </div>
                <div
                  class="fs-14 btn bg-orange text-white btn-add-trab text-uppercase"
                  @click="adicionarLinks()"
                >
                  Adicionar
                </div>
                <div
                  class="fs-14 btn btn-success btn-atualizar text-uppercase"
                  @click="atualizarLinks()"
                >
                  Salvar Links
                </div>
              </div>
            </td>
          </tr>
          <tr v-else>
            <td>
              <div
                class="fs-14 btn bg-orange text-white btn-add-trab text-uppercase"
                @click="adicionarLinks()"
              >
                Adicionar
              </div>
              <div
                class="fs-14 btn btn-success btn-atualizar text-uppercase"
                @click="atualizarLinks()"
              >
                Salvar Links
              </div>
            </td>
          </tr>

          <hr class="my-3" />
          <tr>
            <td>
              <h5 class="font-weight-bold text-uppercase">
                Adicionar fotos dos trabalhos
              </h5>
            </td>
          </tr>
          <tr>
            <div class="row m-0">
              <div
                class="col-lg-4 col-md-6 col-sm-12 col-12 p-0"
                v-for="(trabalho, index) in profTrabalhos"
                :key="index"
              >
                <div
                  class="btn-remove"
                  @click="removerTrabalhos(index, trabalho.id)"
                >
                  <i class="fas fa-times"></i>
                </div>
                <img
                  class="img w-100"
                  :src="`${getImagesAddress}` + trabalho.nome_foto"
                  :alt="'Foto ' + [index + 1] + ' do trabalho do profissional'"
                />
              </div>

              <div class="custom-file m-t-20">
                <input
                  type="file"
                  id="arquivo_trab"
                  lang="pt"
                  class="custom-file-input c-pointer"
                  @change="adicionarTrabalho()"
                  multiple
                />
                <label class="custom-file-label" for="arquivo_trab">{{
                  arquivo.name
                }}</label>
              </div>
              <div
                class="fs-14 btn btn-success btn-atualizar text-uppercase m-10-0"
                @click="atualizarTrabalhos()"
              >
                Salvar Trabalhos
              </div>
            </div>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters } from "vuex";
import { setTimeout } from "timers";
import api from "../../api/index";
import ProfessionalPlans from "../../enums/ProfessionalPlans";
import Visualizations from "../../components/Professional/Visualizations.vue";
import scrollToElement from "../../mixins/scrollToElement";

export default {
  mixins: [scrollToElement],
  name: "perfil",
  components: {
    Visualizations,
  },
  data: () => ({
    ProfessionalPlans,
    foto_principal: null,
    arquivo: {
      name: 'Adicione as fotos para o seu portfólio',
    },
  }),
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapState({
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      profissional: (state) => state.profissional,
      profProfissoes: (state) => {
        if (state.profissional !== null) {
          if (state.profissional[0].profissoes !== null) {
            return state.profissional[0].profissoes;
          }
        }
      },
      profCidades: (state) => {
        if (state.profissional !== null) {
          if (state.profissional[0].cidades !== null) {
            return state.profissional[0].cidades;
          }
        }
      },
      profLinks: (state) => {
        if (state.profissional !== null) {
          if (state.profissional[0].links !== null) {
            return state.profissional[0].links;
          }
        }
      },
      profTrabalhos: (state) => {
        if (state.profissional !== null) {
          if (state.profissional[0].trabalhos !== null) {
            return state.profissional[0].trabalhos;
          }
        }
      },
      tipoProfissoes: (state) => state.tipoProfissoes,
      cidades: (state) => state.cidades,
    }),
    ...mapGetters([
      'getInformacaoUpload',
      'getNotification',
      'getTipoNotification',
      'getBaseUri',
    ]),
  },
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadTipoProfissoes');
    this.$store.dispatch('showProfissional', this.dadosUsuario.informacoes.id);
    this.scrollToElement();
  },
  beforeMount() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }
  },
  mounted(){
    this.scrollToElement();
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    updateImageAndDescription() {
      const self = this;
      const data = {
        id: this.dadosUsuario.id,
        id_profissional: this.dadosUsuario.informacoes.id,
        foto_principal: this.foto_principal,
        profissional_resumo: this.profissional[0].profissional_resumo || '',
      };

      if(data.profissional_resumo.length <= 500) {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('updateProfissionalPerfil', data)
          .then(() => {
            self.aviso('Dados atualizados com sucesso!', 'success');

            self.profissional[0].foto_principal = self.foto_principal;
            self.foto_principal = null;

            self.$store.dispatch('endLoader');
          })
          .catch(() => {
            self.aviso('Houve um problema ao salvar o resumo e sua foto de perfil, tente novamente em 5 minutos!', 'danger');
            self.$store.dispatch('endLoader');
          });
      } else {
        self.aviso('Por favor, digite no máximo 500 caracteres!', 'danger');
      }
    },
    adicionarProfissao() {
      if (this.profissional[0].profissoes === null) {
        this.profissional[0].profissoes = [{}];
      } else if (
        this.profissional[0].profissoes.length >= 1 &&
        (this.profissional[0].plano === null ||
          this.profissional[0].plano_id === 1)
      ) {
        this.aviso(
          'Você já atingiu o limite máximo de profissões do seu plano!',
          'warning'
        );
      } else if (
        this.profissional[0].profissoes.length >= 2 &&
        this.profissional[0].plano_id === 2
      ) {
        this.aviso(
          'Você já atingiu o limite máximo de profissões do seu plano!',
          'warning'
        );
      } else if (
        this.profissional[0].profissoes.length >= 3 &&
        this.profissional[0].plano_id === 3
      ) {
        this.aviso(
          'Você já atingiu o limite máximo de profissões do seu plano!',
          'warning'
        );
      } else if (this.profissional[0].plano_id === 4) {
        this.profissional[0].profissoes.push({});
      } else {
        this.profissional[0].profissoes.push({});
      }
    },
    adicionarCidade() {
      if (this.profissional[0].cidades === null) {
        this.profissional[0].cidades = [
          {
            id: 1,
            nome: 'Acrelândia',
            estado: 'Acre',
            estado_uf: 'AC',
            criado_em: '2019-04-26 12:35:29',
            atualizado_em: '2019-04-26 12:35:29',
          },
        ];
      } else {
        this.profissional[0].cidades.push({});
      }
    },
    adicionarLinks() {
      if (this.profissional[0].links === null) {
        this.profissional[0].links = [
          {
            id: 1,
            link: 'https://www.google.com.br',
            criado_em: '2019-05-27 10:56:00',
            atualizado_em: '2019-05-27 10:56:00',
          },
        ];
      } else {
        this.profissional[0].links.push({});
      }
    },
    adicionarFotoPrincipalNaTroca() {
      const self = this;
      const imagemField = document.getElementById('foto_principal');
      const formData = new FormData();
      formData.append('file', imagemField.files[0]);

      this.$store.dispatch('startLoader');
      api.post(`${self.getBaseUri}upload-file`, formData, {
          headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${self.token}`}
        })
        .then((data) => {
          if(data.data.data && data.data.data != '') {
            self.foto_principal = data.data.data;
          }
        })
        .catch(() => {
          self.aviso('Houve um problema na hora de enviar o arquivo, tente novamente em 5 minutos!', 'danger');
        }).finally(() => {
          self.$store.dispatch('endLoader');
        })
    },
    adicionarTrabalho() {
      const self = this;
      const imagemField = document.getElementById('arquivo_trab');
      const formData = new FormData();

      if (imagemField.files.length > 0) {
        let x = 0;
        for (const value of imagemField.files) {
          formData.append(`files[${x}]`, value);
          x++;
        }
      }

      self.$store.dispatch('startLoader');
      api
        .post(`${self.getBaseUri}upload-files`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${self.token}`,
          },
        })
        .then((data) => {
          setTimeout(() => {
            if (data.data.data !== null) {
              if (data.data.data.length > 0) {
                for (const foto of data.data.data) {
                  if (self.profissional[0].trabalhos === null) {
                    self.profissional[0].trabalhos = [
                      {
                        nome_foto: foto,
                      },
                    ];
                  } else {
                    self.profissional[0].trabalhos.push({
                      nome_foto: foto,
                    });
                  }
                }
              }
            }
            self.$store.dispatch('endLoader');
          }, 1000);
          self.aviso('Seu trabalho foi inserido com sucesso!', 'success');
        })
        .catch(() => {
          self.aviso(
            'Houve um problema na hora de enviar o arquivo!',
            'danger'
          );
          self.$store.dispatch('endLoader');
        });
    },
    atualizarProfissao() {
      const data = {
        id: this.dadosUsuario.informacoes.id,
        profissoes: this.profProfissoes,
      };
      this.$store.dispatch('updateProfissoesProfissional', data).then(() => {
        setTimeout(() => {
          this.$store
            .dispatch('showProfissional', this.dadosUsuario.informacoes.id)
            .then(() => {
              if (this.getTipoNotification === 1) {
                this.aviso(
                  'Suas Profissões foram selecionadas com sucesso!',
                  'success'
                );
              } else if (this.getTipoNotification === 3) {
                this.aviso(this.getNotification, 'danger');
              }
            });
        }, 1000);
      });
    },
    atualizarCidade() {
      const data = {
        id: this.dadosUsuario.informacoes.id,
        cidades: this.profCidades,
      };
      this.$store.dispatch('updateCidadesProfissional', data).then(() => {
        setTimeout(() => {
          this.$store
            .dispatch('showProfissional', this.dadosUsuario.informacoes.id)
            .then(() => {
              if (this.getTipoNotification === 1) {
                this.aviso(
                  'Suas Cidades foram selecionadas com sucesso!',
                  'success'
                );
              } else if (this.getTipoNotification === 3) {
                this.aviso(this.getNotification, 'danger');
              }
            });
        }, 1000);
      });
    },
    atualizarLinks() {
      const data = {
        id: this.dadosUsuario.informacoes.id,
        links: this.profLinks,
      };
      this.$store.dispatch('updateLinksProfissional', data).then(() => {
        setTimeout(() => {
          this.$store
            .dispatch('showProfissional', this.dadosUsuario.informacoes.id)
            .then(() => {
              if (this.getTipoNotification === 1) {
                this.aviso(
                  'Seus Links foram selecionados com sucesso!',
                  'success'
                );
              } else if (this.getTipoNotification === 3) {
                this.aviso(this.getNotification, 'danger');
              }
            });
        }, 1000);
      });
    },
    atualizarTrabalhos() {
      const data = {
        id: this.dadosUsuario.informacoes.id,
        trabalhos: this.profTrabalhos,
      };
      this.$store.dispatch('updateTrabalhosProfissional', data).then(() => {
        setTimeout(() => {
          this.$store
            .dispatch('showProfissional', this.dadosUsuario.informacoes.id)
            .then(() => {
              if (this.getTipoNotification === 1) {
                this.aviso('Fotos selecionadas com sucesso!', 'success');
              } else if (this.getTipoNotification === 3) {
                this.aviso(this.getNotification, 'danger');
              }
            });
        }, 1000);
      });
    },
    removerPrincipal() {
      this.foto_principal = null;
    },
    removerProfFoto() {
      this.profissional[0].foto_principal = null;
    },
    removerProfissoes(index) {
      this.profissional[0].profissoes.splice(index, 1);
    },
    removerCidades(index) {
      this.profissional[0].cidades.splice(index, 1);
    },
    removerLinks(index) {
      this.profissional[0].links.splice(index, 1);
    },
    removerTrabalhos(index, id) {
      if (window.confirm('Deseja realmente deletar essa foto ?')) {
        this.$store
          .dispatch('deleteTrabalhoProfissional', id)
          .then(() => {
            this.$store.dispatch('startLoader');
            setTimeout(() => {
              this.profissional[0].trabalhos.splice(index, 1);
              this.$store.dispatch('endLoader');
              this.aviso('Sua foto foi deletada com sucesso!', 'success');
            }, 1500);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.aviso(
              'Não foi possível deletar o trabalho! Tente novamente em 5 minutos!',
              'danger'
            );
          });
      }
    },
    contratarDestaque() {
      const data = {
        profissional_id: this.profissional[0].id,
      };

      if (this.profissional[0].contratoDestaque === null) {
        this.$store.dispatch('insertContrateAqui', data).then((data) => {
          this.$store.dispatch('startLoader');
          setTimeout(() => {
            this.$store.dispatch('endLoader');
            this.aviso(
              'O seu pedido foi enviado com sucesso! A Constr Up retornará com a resposta em breve.',
              'success'
            );
            this.$store.dispatch(
              'showProfissional',
              this.dadosUsuario.informacoes.id
            );
          }, 1500);
        });
      } else {
        this.aviso(
          'Você já fez um pedido para destaque, espere até receber um e-mail!',
          'warning'
        );
      }
    },
  },
};
</script>
